import CR from './Cr_page.js';
import Teacher from './Teacher_page.js';
const Information = () => {
	return (
		<>
			<CR />
			<Teacher />
		</>
	);
};
export default Information;
